export type EnumAccessLevel = "STUDENT" | "FINANCE" | "TEACHER" | "ADMIN";

export type EnumUserType = "ADMIN" | "USER";

export enum EnumExamType {
  LESSON_TEST = "Avaliação de aula",
  MODULE_TEST = "Avaliação de módulo",
  LEVEL_EXAM = "Exame de nível",
}

export type IEnumExamType = keyof typeof EnumExamType;
